import { Trans } from '@lingui/react/macro'
import { Pencil } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const ContentContainer = styled.div`
  font-size: 0.875rem;
`

const MainText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.defaultText};
  margin-bottom: 0.25rem;
`

export const CaseContentUpdatedContent: React.FC = () => {
  return (
    <ContentContainer>
      <MainText>
        <Pencil size={16} />
        <Trans>Updated case content</Trans>
      </MainText>
    </ContentContainer>
  )
}
